import { Input } from "antd";
import { NumericFormat } from "react-number-format";

interface NumberInputProps {
  value?: number;
  onChange?: (value: number | null) => void;
  tipo?: string; // inteiro = i, c = currency, p = percentual
  precisao?: number;
  disabled?: boolean;
  min?: number;
  max?: number;
  style?: any;
  readonly?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  props?: any;
}

const NumberInput = ({ value, onChange, tipo = "i", precisao = 2, disabled = false, min, max, style = { width: "100%", textAlign: "right" }, readonly, onBlur, props }: NumberInputProps) => {
  return (
    <NumericFormat
      value={value}
      isAllowed={(values) => {
        const { floatValue } = values;
        if (tipo === "p") {
          return floatValue === undefined || (floatValue >= 0 && (max !== undefined ? floatValue <= max : floatValue <= 100));
        }
        if (tipo === "i") {
          if (min !== undefined && max !== undefined) {
            return floatValue === undefined || (floatValue >= min && floatValue <= max);
          }
          if (min !== undefined) {
            return floatValue === undefined || floatValue >= min;
          }
          if (max !== undefined) {
            return floatValue === undefined || floatValue <= max;
          }
        }
        return true;
      }}
      thousandSeparator="."
      decimalSeparator=","
      prefix={tipo === "c" ? "R$ " : ""}
      suffix={tipo === "p" ? "%" : ""}
      decimalScale={precisao}
      fixedDecimalScale
      customInput={Input}
      onValueChange={(values) => {
        onChange?.(values.floatValue ?? null);
      }}
      disabled={disabled}
      readOnly={readonly}
      style={style}
      onBlur={onBlur}
      {...props}
    />
  );
};

export default NumberInput;
